module.exports = __webpack_public_path__ + "img/main_header_bgimg_202503.39a2ba5c.png";